var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiFileUpload = function SvgAiFileUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "var(--icon-stroke-width, 1.2)",
    d: "M5.206 14.328c-1.432 0-2.593-.896-2.593-2.21s1.16-2.38 2.593-2.38c.097 0 .193.006.288.015V9.74h.035a3.923 3.923 0 0 1-.035-.529c0-2.335 2.063-4.229 4.609-4.229 1.724 0 3.226.868 4.017 2.154.193-.026.39-.04.592-.04 2.227 0 4.033 1.657 4.033 3.701 0 1.683-1.224 2.965-2.899 3.388m-5.294 3.344v-6.071m0 0-2.646 2.504m2.646-2.504 2.648 2.504"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B7BBC2",
    d: "m2.476 5.793.597.88.88.596-.88.597-.597.88-.597-.88L1 7.27l.88-.597.596-.879ZM15.382 16.548l.597.879.879.597-.88.597-.596.879-.598-.88-.879-.596.88-.597.597-.88Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m15.68.5.683 1.847 1.847.683-1.847.684-.683 1.847-.684-1.847-1.847-.684 1.847-.683L15.68.5Z"
  })));
};
export default SvgAiFileUpload;